<div class="p-3 sm:p-6 chart-page-container flex flex-col" *transloco="let t">
  <div class="bg-white shadow-lg rounded-lg p-4 sm:p-6 flex-1 flex flex-col card-scroll">
    <div class="flex items-baseline mb-1">
      <span class="ml-auto text-xs text-gray-400">{{ t('charts.updatedAt') }} {{lastUpdated | date: 'dd/MM/yyyy HH:mm'}}</span>
    </div>

    <div class="flex flex-col sm:flex-row flex-wrap items-start sm:items-center gap-3 mb-3">
      <div class="flex items-center gap-2 flex-wrap">
        <label class="text-sm font-medium text-gray-700 whitespace-nowrap">{{ t('charts.period') }}</label>
        <select [(ngModel)]="period" (change)="onPeriodChange()"
          class="px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 text-sm w-full sm:w-auto">
          <option [ngValue]="1">{{ t('charts.last7') }}</option>
          <option [ngValue]="2">{{ t('charts.last15') }}</option>
          <option [ngValue]="3">{{ t('charts.last30') }}</option>
          <option [ngValue]="4">{{ t('charts.allTime') }}</option>
        </select>
      </div>

      <div class="flex items-center gap-2 flex-wrap">
        <label class="text-sm font-medium text-gray-700 whitespace-nowrap">{{ t('charts.top') }}</label>
        <input type="number" min="1" [max]="chartType === 'donut' ? 20 : 200" [(ngModel)]="top" (change)="onTopChange()"
          class="w-24 px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 text-sm" />
      </div>

      <div class="flex items-center gap-2 ml-auto flex-wrap">
        <label class="text-sm font-medium text-gray-700 whitespace-nowrap">{{ t('charts.visualization') }}</label>
        <div class="inline-flex items-center border border-gray-300 rounded-md overflow-hidden">
        <button type="button" (click)="setChartType('bar')"
          class="px-3 py-2 text-sm focus:outline-none"
          [class.bg-blue-50]="chartType==='bar'" [class.text-blue-700]="chartType==='bar'">
          <span class="inline-block align-middle">▤</span>
        </button>
        <button type="button" (click)="setChartType('treemap')"
          class="px-3 py-2 text-sm border-l border-gray-300 focus:outline-none"
          [class.bg-blue-50]="chartType==='treemap'" [class.text-blue-700]="chartType==='treemap'">
          <span class="inline-block align-middle">▦</span>
        </button>
        <button type="button" (click)="setChartType('donut')"
          class="px-3 py-2 text-sm border-l border-gray-300 focus:outline-none"
          [class.bg-blue-50]="chartType==='donut'" [class.text-blue-700]="chartType==='donut'">
          <span class="inline-block align-middle">◔</span>
        </button>
        </div>
      </div>
    </div>

    <div class="flex-1 min-h-0 w-full relative" style="max-width: 100%; overflow: visible; min-height: 320px;">
      <apx-chart *ngIf="!loading" [series]="chartOptions.series" [chart]="chartOptions.chart"
        [xaxis]="chartOptions.xaxis" [plotOptions]="chartOptions.plotOptions" [labels]="chartOptions.labels"
        [legend]="chartOptions.legend" [dataLabels]="chartOptions.dataLabels" [title]="chartOptions.title"
        [tooltip]="chartOptions.tooltip" [responsive]="chartOptions.responsive" [theme]="chartOptions.theme" style="height:100%; width:100%; display:block;">
      </apx-chart>

      <div *ngIf="loading" class="absolute inset-0 flex flex-col items-center justify-center gap-3 text-gray-500">
        <span class="h-9 w-9 rounded-full border-4 border-gray-200 border-t-blue-600 animate-spin"></span>
        <span class="text-sm">{{ t('common.loading') }}</span>
      </div>
    </div>
  </div>
</div>
